<br>

<div style="width: auto; overflow: auto">
    <!-- <common-list-table [request]="getRequest" [cols]="cols" action-button-text="Añadir formulaio 2" (action-button-click)="add()" [global-conditional-style]="globalConditionalStyle"> -->
    <app-common-list-table [request]="getRequest" [cols]="cols" [globalVisualTransform]="globalVisualTransform" [globalConditionalStyle]="globalConditionalStyle">
    
        <ng-template #thEnd>
            <th>
                <p class="d-flex justify-content-center" style="margin-bottom: 0">Acciones</p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
            <td>
                <app-action-buttons
                    [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''" 
                [hideDelete]="true" [hideEdit]="true"  (editRowButtonEvent)="edit()" (deleteRowButtonEvent)="show('delete', data.data)" (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>
        </ng-template>
    </app-common-list-table>
</div>


<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>

